module.exports = __webpack_public_path__ + "img/linkedin.34c3c12a.svg";